import { CellInformation, ScriptLinkItem } from ".";
import { Department } from "../../department";

export class ExecuteRequest {
  public patientId: string;
  public department: Department;
  public exePath: string;
  public csvPath: string;
  public xmlValuePath: string;
  public csvBeforeValuePath: string;
  public csvInputValuePath: string;
  public arguments: string[];
  public splitter: string;
  public values: CellInformation[];
  public scriptLinkItems: ScriptLinkItem[];
  public previousCompressedCsvText: string;
}
